import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchAgencyVenues = ({ payload }: { payload: { venueName: string, employerId?: number } }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/admin/venues', reqArgs: { venue_name: payload.venueName, employer_id: payload.employerId } })
    handleCall(req, resolve, reject)
  })
